import swal from 'sweetalert'

const withConfirmation = (cb, opts, secondaryCb) => {
  const { title, text, cancelText = 'Cancel', acceptText = 'Yes', buttons } = opts
  return async (...args) => {
    const willConfirm = await swal({
      title,
      text,
      buttons: buttons || [cancelText, acceptText]
    })
    if (willConfirm === 'secondaryConfirm') {
      return secondaryCb(...args)
    }
    if (willConfirm) {
      return cb(...args)
    }
  }
}

export default withConfirmation
